import React, { useState } from 'react'
import { Modal } from 'uiComponents/popups/modal.new'
import { ChooseDiscountType } from './chooseDiscountType'
import { DiscountCodeForm, DiscountCodeFormSchema, DiscountType } from '../_shared'
import { removeHash } from 'utils/hash'
import { showSuccessMessage } from 'uiComponents/message'
import { useAppSelector } from 'store/hooks'
import { getDiscountPools } from '../redux'
import '../_shared/modal.scss'
import { useTranslation } from 'translations'

interface addDiscountModalProps {
    selectedPoolUuid?: string
}

export const AddDiscountModal = ({ selectedPoolUuid }: addDiscountModalProps) => {
    const { t } = useTranslation()
    const [selectedDiscountType, setSelectedDiscountType] = useState<DiscountType | null>(null)
    const getTitle = () => {
        switch (selectedDiscountType) {
            case 'cart':
                return t('discounts.addDiscount.createCartTitle')
            case 'product':
                return t('discounts.addDiscount.createProductTitle')
            default:
                return t('discounts.addDiscount.chooseTypeTitle')
        }
    }
    const title = getTitle()
    const discountPools = useAppSelector(getDiscountPools)

    const afterSubmit = (discount: DiscountCodeFormSchema) => {
        removeHash()
        const discountPool = discountPools?.find((pool) => pool.uuid === discount.poolUuid)
        showSuccessMessage(
            discountPool?.name
                ? t('discounts.addDiscount.createdInPoolSuccess', { code: discount.code, pool: discountPool?.name })
                : t('discounts.addDiscount.createdSuccess', { code: discount.code }),
        )
    }

    return (
        <Modal onDismiss={removeHash} title={title} className="add-discount-modal">
            {!selectedDiscountType && <ChooseDiscountType onSelectDiscountType={setSelectedDiscountType} />}
            {selectedDiscountType && (
                <DiscountCodeForm
                    discountType={selectedDiscountType}
                    selectedPoolUuid={selectedPoolUuid}
                    onCancel={() => setSelectedDiscountType(null)}
                    afterSubmit={afterSubmit}
                />
            )}
        </Modal>
    )
}
